import request from '@/config/axios'

// 获取班次配置
export const GetWorkShift = (params) => {
  return request.get({
    url: 'oee/workshift',
    baseUrl:'m2i',
    params
  })
}

// 保存班次配置
export const SetWorkShift = (data) => {
  return request.put({
    url: 'oee/workshift',
    data:data,
    baseUrl:'m2i'
  })
}

// 优良差设备数量
export const GetDeviceCount = (params) => {
  return request.get({
    url: 'oee/devicecount',
    params,
    baseUrl:'m2i'
  })
}

export const GetPrecautionsByIds = (params) => {
  return request.get({
    url: 'oee/precautions/byid',
    params,
    baseUrl:'m2i'
  })
}

export const SetPrecautions = (data) => {
  return request.post({
    url: 'oee/precautions',
    data,
    baseUrl:'m2i'
  })
}

export const GetDeviceInfoSetting = (params) => {
  return request.get({
    url: 'oee/device/information',
    params,
    baseUrl:'m2i'
  })
}

export const SaveDeviceInfoSetting = (data) => {
  return request.post({
    url: 'oee/device/information',
    data,
    baseUrl:'m2i'
  })
}

export const GetDeviceImg = (params) => {
  return request.get({
    url: 'oee/image/base64',
    params,
    baseUrl:'m2i'
  })
}